import { useFormikContext } from "formik";
import React, { useState, useEffect } from "react";
import { labelName } from "../../utils/functions";
import TextFieldStyles from "../Input/TextField/TextField.module.css";
import DistanceFieldStyles from "./Distance.module.css";
import ErrorMessage from "../Input/ErrorrMessage";

// Array of unit options for the dropdown specific to distance
const unitOfMeasure = [
  "Kilometers",
  "Meters",
  "Miles",
  "Yards",
  "Feet",
  "Inches",
  "Centimeters",
];

// Distance component for capturing distance-related inputs
export default function Distance({ field_label, displayLabel, parent, isRequired, initialValue }) {
  // Access Formik's context to set field values
  const { setFieldValue } = useFormikContext();

  // Construct the field name based on parent and field_label
  const name = parent ? `${parent}.${field_label}` : field_label;

  // State to hold the distance values (unit, length, width, height, quantity)
  const [distance, setDistance] = useState(parseDistance(initialValue));

  const distanceToSave = Object.entries(distance)
    .map(([key, value]) => `${key}: ${value?.trim()}`)
    .join(",");

  // Update the Formik field value whenever the distance state changes
  useEffect(() => {
    setFieldValue(name, distanceToSave);
  }, [distanceToSave, name, setFieldValue]);

  // Function to update a specific index in the distance array
  const updateDistance = (key, value) => {
    setDistance(prev => ({
        ...prev,
        [key]: value
    }));
  };

  function parseDistance(value) {
    const defaults = {
      uom: "Kilometers",
      distance: ""
    };

    if (!value) return defaults;

    return value.split(",").reduce((acc, item) => {
      const [key, val] = item.split(":").map(s => s.trim());
      if (key && val !== undefined) {
        acc[key] = val;
      }
      return acc;
    }, { ...defaults });
  };

  return (
    <div className={TextFieldStyles.inputContainer}>
      {/* Label for the input field */}
      <div
        className="label-container"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <label htmlFor="textarea" className={TextFieldStyles.label}>
          {labelName(displayLabel || field_label)}
          {isRequired === "true" && (
            <span style={{ color: "#d32f2f", padding: 0 }}>*</span>
          )}
        </label>
      </div>
      <div style={{ fontFamily: "Arial, sans-serif" }}>
        {/* Hidden input to store the serialized distance state */}
        <input type="hidden" name={name} value={distanceToSave} />
        <div style={{ display: "flex", gap: "1em", alignItems: "center" }}>
          {/* Dropdown for selecting the unit of measure */}
          <div style={{ display: "grid", gap: ".8em" }}>
            <label className={TextFieldStyles.label}>Unit of Measure</label>
            <select
              style={{
                width: "min-content",
                fontFamily: "Arial, sans-serif",
                border: "none",
                borderBottom: "none",
                outline: "none",
              }}
              value={distance.uom}
              onChange={(e) => updateDistance("uom", e.target.value)}
            >
              {unitOfMeasure.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </div>
          {/* Input for distance */}
          <div>
            <label className={TextFieldStyles.label}>Distance</label>
            <input
              type="number"
              placeholder="Enter Distance"
              className={DistanceFieldStyles.input}
              value={distance.distance}
              onChange={(e) => updateDistance("distance", e.target.value)}
            />
          </div>
        </div>
      </div>
      {/* Display error message if validation fails */}
      <ErrorMessage name={name} />
    </div>
  );
}
